import { useLazyQuery } from 'src/graphql';
import { DATASHEET_QUESTION_RESULT_COMMENTS } from 'src/graphql/job/query';

export default (variables, skip = false) => 
  useLazyQuery(DATASHEET_QUESTION_RESULT_COMMENTS, {
    variables,
    skip,
  });
  